import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class BigSquidCorpse extends OrganicMobCorpse {
	static key = "BigSquidCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): BigSquidCorpse {
		const c = new BigSquidCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
